exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".support-article{position:relative;text-align:left;border-bottom:1px solid #d5d5d5}.support-article .faq-question-arrow{float:left}.support-article>a{display:block;padding:20px 0}.support-article>a:active,.support-article>a:focus,.support-article>a:hover{outline:none}.support-article>a:active .article-heading,.support-article>a:focus .article-heading,.support-article>a:hover .article-heading{color:#111821}.support-article .collapsing{transition:height .35s ease}.article-heading{margin:0 0 0 45px;color:#666}.article-arrow{position:absolute;top:21px;left:10px}@media (min-width:768px){.article-arrow{top:23px}}.article-description{margin:0;padding:0 15px 15px 45px}.article-description ul{margin:0;padding-left:30px;list-style-position:outside;list-style-type:disc}.article-description ul li{color:#41464d}.article-description ol{margin:0;padding-left:30px;list-style-position:outside;list-style-type:decimal}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Support/SupportArticle.scss
 ** module id = 1221
 ** module chunks = 0
 **/